/* ── LC Reviews v1 — first-party product reviews (WhatsApp-verified) ──
 * Renders: summary + list in #lc-reviews section, star badge under the title.
 * Write flow: WA OTP login inline (skipped when lc_wa_session is valid),
 * star rating, text, up to 3 photos (compressed client-side).
 * No third-party review apps. Only real customer data is ever shown.
 */
(function () {
  'use strict';

  var API = (window.__lc && window.__lc.api) || 'https://shopify-connect-manavlakhina.replit.app/api';
  var PAGE_SIZE = 5;

  var root = document.querySelector('[data-lc-reviews]');
  if (!root) return;

  var productId = root.getAttribute('data-product-id');
  var productHandle = root.getAttribute('data-product-handle') || '';
  var productTitle = root.getAttribute('data-product-title') || '';

  var els = {
    summary: root.querySelector('[data-lc-rev-summary]'),
    list: root.querySelector('[data-lc-rev-list]'),
    writeBtn: root.querySelector('[data-lc-rev-write]'),
    formWrap: root.querySelector('[data-lc-rev-form]'),
    moreBtn: root.querySelector('[data-lc-rev-more]')
  };

  var state = { page: 1, pages: 1, count: 0, loadedReviews: [] };

  /* ---------- session helpers ---------- */
  function getSession() {
    try {
      var token = localStorage.getItem('lc_wa_session');
      if (!token) return null;
      var payload = atob(token.replace(/-/g, '+').replace(/_/g, '/'));
      var parts = payload.split(':');
      if (parts.length < 3) return null;
      if (Number(parts[1]) < Date.now()) { return null; } // expired
      return { token: token, customerId: parts[0], name: localStorage.getItem('lc_wa_name') || '' };
    } catch (e) { return null; }
  }

  /* ---------- tiny dom helpers ---------- */
  function h(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }
  function starsHtml(rating, cls) {
    var wrap = h('span', 'lc-stars ' + (cls || ''));
    for (var i = 1; i <= 5; i++) {
      var s = h('span', i <= Math.round(rating) ? 'lc-star lc-star--on' : 'lc-star');
      s.textContent = '★';
      wrap.appendChild(s);
    }
    return wrap;
  }
  function esc(s) { return String(s == null ? '' : s); }

  /* ---------- fetch + render ---------- */
  function load(page, append) {
    return fetch(API + '/reviews/' + productId + '?page=' + page + '&limit=' + PAGE_SIZE)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.ok) throw new Error('bad response');
        state.count = data.summary.count;
        state.page = page;
        state.pages = Math.max(1, Math.ceil(data.summary.count / PAGE_SIZE));
        renderSummary(data.summary);
        renderBadge(data.summary);
        renderList(data.reviews, append);
        els.moreBtn.hidden = state.page >= state.pages;
      })
      .catch(function () {
        if (els.summary) {
          els.summary.textContent = '';
          els.summary.appendChild(h('p', 'lc-reviews__empty', 'Reviews are temporarily unavailable.'));
        }
      });
  }

  function renderSummary(sum) {
    els.summary.textContent = '';
    if (!sum.count) {
      var empty = h('div', 'lc-reviews__empty-wrap');
      empty.appendChild(h('p', 'lc-reviews__empty', 'No reviews yet.'));
      empty.appendChild(h('p', 'lc-reviews__empty-sub', 'Bought this piece? Be the first to share how it turned out.'));
      els.summary.appendChild(empty);
      return;
    }
    var wrap = h('div', 'lc-rev-summary');
    var left = h('div', 'lc-rev-summary__avg');
    left.appendChild(h('div', 'lc-rev-summary__num', String(sum.average)));
    left.appendChild(starsHtml(sum.average, 'lc-stars--lg'));
    var vc = sum.verifiedCount ? ' · ' + sum.verifiedCount + ' verified buyer' + (sum.verifiedCount > 1 ? 's' : '') : '';
    left.appendChild(h('div', 'lc-rev-summary__count', sum.count + ' review' + (sum.count > 1 ? 's' : '') + vc));
    wrap.appendChild(left);

    var bars = h('div', 'lc-rev-summary__bars');
    for (var r = 5; r >= 1; r--) {
      var n = sum.distribution[String(r)] || 0;
      var row = h('div', 'lc-rev-bar');
      row.appendChild(h('span', 'lc-rev-bar__label', r + '★'));
      var track = h('span', 'lc-rev-bar__track');
      var fill = h('span', 'lc-rev-bar__fill');
      fill.style.width = (sum.count ? Math.round((n / sum.count) * 100) : 0) + '%';
      track.appendChild(fill);
      row.appendChild(track);
      row.appendChild(h('span', 'lc-rev-bar__n', String(n)));
      bars.appendChild(row);
    }
    wrap.appendChild(bars);
    els.summary.appendChild(wrap);
  }

  function renderBadge(sum) {
    var badge = document.querySelector('[data-lc-rev-badge]');
    if (!badge) return;
    if (!sum.count) { badge.hidden = true; return; }
    badge.textContent = '';
    var a = h('a', 'lc-rev-badge__link');
    a.href = '#lc-reviews';
    a.appendChild(starsHtml(sum.average, ''));
    a.appendChild(h('span', 'lc-rev-badge__txt', sum.average + ' (' + sum.count + ')'));
    a.addEventListener('click', function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    badge.appendChild(a);
    badge.hidden = false;
  }

  function renderList(reviews, append) {
    if (!append) els.list.textContent = '';
    reviews.forEach(function (r) {
      var card = h('article', 'lc-rev-card');
      var head = h('div', 'lc-rev-card__head');
      head.appendChild(starsHtml(r.rating, ''));
      var who = h('div', 'lc-rev-card__who');
      who.appendChild(h('span', 'lc-rev-card__author', esc(r.author)));
      if (r.verifiedBuyer) who.appendChild(h('span', 'lc-rev-card__verified', '✓ Verified Buyer'));
      var d = new Date(r.createdAt);
      if (!isNaN(d)) who.appendChild(h('span', 'lc-rev-card__date', d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })));
      head.appendChild(who);
      card.appendChild(head);
      if (r.title) card.appendChild(h('h4', 'lc-rev-card__title', esc(r.title)));
      card.appendChild(h('p', 'lc-rev-card__body', esc(r.body)));
      if (r.images && r.images.length) {
        var imgs = h('div', 'lc-rev-card__imgs');
        r.images.forEach(function (src) {
          var img = document.createElement('img');
          img.loading = 'lazy';
          img.src = API.replace(/\/api$/, '') + src;
          img.alt = 'Customer photo';
          img.addEventListener('click', function () { openLightbox(img.src); });
          imgs.appendChild(img);
        });
        card.appendChild(imgs);
      }
      els.list.appendChild(card);
    });
  }

  function openLightbox(src) {
    var ov = h('div', 'lc-rev-lightbox');
    var img = document.createElement('img');
    img.src = src;
    ov.appendChild(img);
    ov.addEventListener('click', function () { ov.remove(); });
    document.body.appendChild(ov);
  }

  /* ---------- write-review form ---------- */
  var formState = { rating: 0, images: [], busy: false };

  function buildForm() {
    els.formWrap.textContent = '';
    formState.rating = 0;
    formState.images = [];

    var session = getSession();
    var form = h('div', 'lc-rev-form');

    form.appendChild(h('p', 'lc-rev-form__heading', 'Share your experience'));

    /* star input */
    var starRow = h('div', 'lc-rev-form__stars');
    var starBtns = [];
    for (var i = 1; i <= 5; i++) {
      (function (val) {
        var b = h('button', 'lc-rev-form__star', '★');
        b.type = 'button';
        b.setAttribute('aria-label', val + ' star' + (val > 1 ? 's' : ''));
        b.addEventListener('click', function () {
          formState.rating = val;
          starBtns.forEach(function (sb, idx) {
            sb.classList.toggle('is-on', idx < val);
          });
        });
        starBtns.push(b);
        starRow.appendChild(b);
      })(i);
    }
    form.appendChild(starRow);

    var titleIn = document.createElement('input');
    titleIn.type = 'text';
    titleIn.maxLength = 100;
    titleIn.placeholder = 'Title (optional)';
    titleIn.className = 'lc-rev-form__input';
    form.appendChild(titleIn);

    var bodyIn = document.createElement('textarea');
    bodyIn.maxLength = 2000;
    bodyIn.rows = 4;
    bodyIn.placeholder = 'How was the fit, fabric and stitching? What did you wear it for?';
    bodyIn.className = 'lc-rev-form__input lc-rev-form__textarea';
    form.appendChild(bodyIn);

    /* photos */
    var photoRow = h('div', 'lc-rev-form__photos');
    var thumbs = h('div', 'lc-rev-form__thumbs');
    var addBtn = h('button', 'lc-rev-form__addphoto', '+ Add photos (up to 3)');
    addBtn.type = 'button';
    var fileIn = document.createElement('input');
    fileIn.type = 'file';
    fileIn.accept = 'image/jpeg,image/png,image/webp';
    fileIn.multiple = true;
    fileIn.hidden = true;
    addBtn.addEventListener('click', function () { fileIn.click(); });
    fileIn.addEventListener('change', function () {
      var files = Array.prototype.slice.call(fileIn.files || []);
      files.forEach(function (f) {
        if (formState.images.length >= 3) return;
        compressImage(f, function (dataUrl) {
          if (!dataUrl || formState.images.length >= 3) return;
          formState.images.push(dataUrl);
          var t = h('span', 'lc-rev-form__thumb');
          var im = document.createElement('img');
          im.src = dataUrl;
          var x = h('button', 'lc-rev-form__thumb-x', '×');
          x.type = 'button';
          x.addEventListener('click', function () {
            var idx = formState.images.indexOf(dataUrl);
            if (idx > -1) formState.images.splice(idx, 1);
            t.remove();
            addBtn.hidden = formState.images.length >= 3;
          });
          t.appendChild(im);
          t.appendChild(x);
          thumbs.appendChild(t);
          addBtn.hidden = formState.images.length >= 3;
        });
      });
      fileIn.value = '';
    });
    photoRow.appendChild(thumbs);
    photoRow.appendChild(addBtn);
    photoRow.appendChild(fileIn);
    form.appendChild(photoRow);

    var msg = h('p', 'lc-rev-form__msg');
    msg.hidden = true;
    form.appendChild(msg);

    /* auth area (only when no valid session) */
    var authWrap = h('div', 'lc-rev-auth');
    var authState = { verified: !!session, phone: '' };
    if (!session) buildAuth(authWrap, authState, msg);
    form.appendChild(authWrap);

    var submit = h('button', 'lc-btn-dark lc-rev-form__submit', 'Post review');
    submit.type = 'button';
    submit.addEventListener('click', function () {
      if (formState.busy) return;
      msg.hidden = true;
      var sess = getSession();
      if (!formState.rating) { showMsg(msg, 'Please tap a star rating.', true); return; }
      if ((bodyIn.value || '').trim().length < 10) { showMsg(msg, 'Please write at least a sentence about your experience.', true); return; }
      if (!sess) { showMsg(msg, 'Please verify your WhatsApp number above to post your review.', true); return; }

      formState.busy = true;
      submit.textContent = 'Posting…';
      fetch(API + '/reviews', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sess.token },
        body: JSON.stringify({
          productId: productId,
          productHandle: productHandle,
          productTitle: productTitle,
          rating: formState.rating,
          title: (titleIn.value || '').trim() || undefined,
          body: (bodyIn.value || '').trim(),
          images: formState.images
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          formState.busy = false;
          submit.textContent = 'Post review';
          if (!res.ok) { showMsg(msg, (res.j && res.j.error) || 'Could not post your review. Please try again.', true); return; }
          els.formWrap.hidden = true;
          els.writeBtn.hidden = false;
          showToast(res.j.updated ? 'Your review has been updated. Thank you!' : 'Thank you! Your review is now live.');
          load(1, false);
        })
        .catch(function () {
          formState.busy = false;
          submit.textContent = 'Post review';
          showMsg(msg, 'Network error — please try again.', true);
        });
    });
    form.appendChild(submit);

    var cancel = h('button', 'lc-rev-form__cancel', 'Cancel');
    cancel.type = 'button';
    cancel.addEventListener('click', function () {
      els.formWrap.hidden = true;
      els.writeBtn.hidden = false;
    });
    form.appendChild(cancel);

    els.formWrap.appendChild(form);

    /* prefill when the customer already reviewed this product */
    var sess2 = getSession();
    if (sess2) {
      fetch(API + '/reviews/me/' + productId, { headers: { 'Authorization': 'Bearer ' + sess2.token } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d && d.ok && d.review) {
            formState.rating = d.review.rating;
            starBtns.forEach(function (sb, idx) { sb.classList.toggle('is-on', idx < d.review.rating); });
            titleIn.value = d.review.title || '';
            bodyIn.value = d.review.body || '';
            showMsg(msg, 'You already reviewed this piece — posting again will update your review.', false);
          }
        })
        .catch(function () {});
    }
  }

  function buildAuth(wrap, authState, msg) {
    wrap.textContent = '';
    wrap.appendChild(h('p', 'lc-rev-auth__label', 'Verify with WhatsApp to post (we never show your number)'));
    var row = h('div', 'lc-rev-auth__row');
    var phoneIn = document.createElement('input');
    phoneIn.type = 'tel';
    phoneIn.placeholder = 'WhatsApp number';
    phoneIn.className = 'lc-rev-form__input';
    var sendBtn = h('button', 'lc-btn-light', 'Send OTP');
    sendBtn.type = 'button';
    row.appendChild(phoneIn);
    row.appendChild(sendBtn);
    wrap.appendChild(row);

    var otpRow = h('div', 'lc-rev-auth__row');
    otpRow.hidden = true;
    var otpIn = document.createElement('input');
    otpIn.type = 'tel';
    otpIn.maxLength = 6;
    otpIn.placeholder = '6-digit OTP';
    otpIn.className = 'lc-rev-form__input';
    var verifyBtn = h('button', 'lc-btn-light', 'Verify');
    verifyBtn.type = 'button';
    otpRow.appendChild(otpIn);
    otpRow.appendChild(verifyBtn);
    wrap.appendChild(otpRow);

    sendBtn.addEventListener('click', function () {
      var phone = (phoneIn.value || '').trim();
      if (phone.replace(/\D/g, '').length < 10) { showMsg(msg, 'Please enter a valid WhatsApp number.', true); return; }
      sendBtn.disabled = true;
      sendBtn.textContent = 'Sending…';
      fetch(API + '/auth/otp/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          sendBtn.disabled = false;
          sendBtn.textContent = 'Resend';
          if (!res.ok) { showMsg(msg, (res.j && res.j.error) || 'Could not send OTP.', true); return; }
          authState.phone = phone;
          otpRow.hidden = false;
          showMsg(msg, 'OTP sent on WhatsApp — check your chats.', false);
          otpIn.focus();
        })
        .catch(function () {
          sendBtn.disabled = false;
          sendBtn.textContent = 'Send OTP';
          showMsg(msg, 'Network error — please try again.', true);
        });
    });

    verifyBtn.addEventListener('click', function () {
      var otp = (otpIn.value || '').trim();
      if (otp.length !== 6) { showMsg(msg, 'Please enter the 6-digit OTP.', true); return; }
      verifyBtn.disabled = true;
      verifyBtn.textContent = 'Verifying…';
      fetch(API + '/auth/otp/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: authState.phone, otp: otp })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          verifyBtn.disabled = false;
          verifyBtn.textContent = 'Verify';
          if (!res.ok) { showMsg(msg, (res.j && res.j.error) || 'Verification failed.', true); return; }
          if (res.j.sessionToken) {
            try { localStorage.setItem('lc_wa_session', res.j.sessionToken); } catch (e) {}
            try { if (res.j.customer && res.j.customer.firstName) localStorage.setItem('lc_wa_name', res.j.customer.firstName); } catch (e) {}
            wrap.textContent = '';
            var okLine = h('p', 'lc-rev-auth__done', '✓ Verified' + (res.j.customer && res.j.customer.firstName ? ' — hi ' + res.j.customer.firstName + '!' : ''));
            wrap.appendChild(okLine);
            showMsg(msg, 'You are verified — post your review below.', false);
          } else if (res.j.needsEmail) {
            buildEmailStep(wrap, res.j.verifiedToken, msg);
          }
        })
        .catch(function () {
          verifyBtn.disabled = false;
          verifyBtn.textContent = 'Verify';
          showMsg(msg, 'Network error — please try again.', true);
        });
    });
  }

  function buildEmailStep(wrap, verifiedToken, msg) {
    wrap.textContent = '';
    wrap.appendChild(h('p', 'lc-rev-auth__label', 'Almost done — tell us your name and email'));
    var nameIn = document.createElement('input');
    nameIn.type = 'text';
    nameIn.placeholder = 'Your name';
    nameIn.className = 'lc-rev-form__input';
    var emailIn = document.createElement('input');
    emailIn.type = 'email';
    emailIn.placeholder = 'Email';
    emailIn.className = 'lc-rev-form__input';
    var doneBtn = h('button', 'lc-btn-light', 'Continue');
    doneBtn.type = 'button';
    wrap.appendChild(nameIn);
    wrap.appendChild(emailIn);
    wrap.appendChild(doneBtn);
    doneBtn.addEventListener('click', function () {
      var email = (emailIn.value || '').trim();
      if (!/^\S+@\S+\.\S+$/.test(email)) { showMsg(msg, 'Please enter a valid email.', true); return; }
      doneBtn.disabled = true;
      fetch(API + '/auth/otp/create-account', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ verifiedToken: verifiedToken, email: email, name: (nameIn.value || '').trim() || undefined })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          doneBtn.disabled = false;
          if (!res.ok) { showMsg(msg, (res.j && res.j.error) || 'Could not finish sign-in.', true); return; }
          try { localStorage.setItem('lc_wa_session', res.j.sessionToken); } catch (e) {}
          try { if (res.j.customer && res.j.customer.firstName) localStorage.setItem('lc_wa_name', res.j.customer.firstName); } catch (e) {}
          wrap.textContent = '';
          wrap.appendChild(h('p', 'lc-rev-auth__done', '✓ Verified — post your review below.'));
        })
        .catch(function () { doneBtn.disabled = false; showMsg(msg, 'Network error — please try again.', true); });
    });
  }

  function showMsg(el, text, isError) {
    el.textContent = text;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
  }

  function showToast(text) {
    var t = h('div', 'lc-toast', text);
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-in'); }, 30);
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 400); }, 3500);
  }

  /* client-side compression: max 1200px edge, JPEG q0.8 */
  function compressImage(file, cb) {
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) { cb(null); return; }
    var reader = new FileReader();
    reader.onload = function () {
      var img = new Image();
      img.onload = function () {
        try {
          var max = 1200;
          var w = img.width, hh = img.height;
          if (w > max || hh > max) {
            var ratio = Math.min(max / w, max / hh);
            w = Math.round(w * ratio);
            hh = Math.round(hh * ratio);
          }
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = hh;
          canvas.getContext('2d').drawImage(img, 0, 0, w, hh);
          cb(canvas.toDataURL('image/jpeg', 0.8));
        } catch (e) { cb(null); }
      };
      img.onerror = function () { cb(null); };
      img.src = reader.result;
    };
    reader.onerror = function () { cb(null); };
    reader.readAsDataURL(file);
  }

  /* ---------- wire up ---------- */
  els.writeBtn.addEventListener('click', function () {
    buildForm();
    els.formWrap.hidden = false;
    els.writeBtn.hidden = true;
    els.formWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  els.moreBtn.addEventListener('click', function () { load(state.page + 1, true); });

  load(1, false);
})();
